/* global msjPopUp, popAbierto */
import modal from './modal'
import md5 from 'crypto-js/md5';

(function () {
    let ventana = modal();

    let anterior = localStorage.getItem('popup');
    let actual = md5(msjPopUp.html).toString();

    if (msjPopUp.html !== '' && msjPopUp.html !== '<p><br></p>' && actual !== anterior) {
        window.popAbierto = true;
        setTimeout(function() {
            ventana.open({content: msjPopUp.html});
        }, 1000);
        localStorage.setItem('popup', actual);
    }
})();
